// extracted by mini-css-extract-plugin
export default {"back":"PaymentSuccess_back__RgRsG","heading":"PaymentSuccess_heading__In64v","forwardButton":"PaymentSuccess_forwardButton__-quPY"};